import { baseApi } from 'services'

import { ApplicationParty, PaginatedResults } from '@/types/unlock'

export const applicationPartyV2 = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listApplicationParties: builder.query<PaginatedResults<ApplicationParty[]>, string>({
      query: (external_id) => ({
        url: `v2/applications/${external_id}/application-parties/`,
        method: 'GET',
      }),
      providesTags: ['ApplicationParties'],
    }),
    deleteApplicationParties: builder.mutation<PaginatedResults<ApplicationParty[]>, any>({
      query: ({ application_uuid, uuid }) => ({
        url: `v2/applications/${application_uuid}/application-parties/${uuid}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationParties',
        'ApplicationProfiles',
        'Message',
        'Alert',
      ],
    }),
    updateApplicationParty: builder.mutation<
      ApplicationParty,
      {
        applicationUUID: string
        applicationPartyUUID: string
        party: Partial<ApplicationParty>
        application_party_related?: string
        profile_related?: string
      }
    >({
      query: ({
        applicationUUID,
        applicationPartyUUID,
        party,
        application_party_related,
        profile_related,
      }) => {
        const url = `v2/applications/${applicationUUID}/application-parties/${applicationPartyUUID}/`
        const method = 'PATCH'

        return {
          url,
          method,
          body: { party, application_party_related, profile_related },
        }
      },
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationParties',
        'ApplicationProfiles',
        'Alert',
      ],
    }),
    createApplicationParty: builder.mutation<
      ApplicationParty,
      {
        applicationUUID: string
        type: string
        party: Partial<ApplicationParty>
        application_party_related?: string
        profile_related?: string
      }
    >({
      query: ({ applicationUUID, type, party, application_party_related, profile_related }) => {
        const url = `v2/applications/${applicationUUID}/application-parties/`
        const method = 'POST'

        return {
          url,
          method,
          body: {
            application: applicationUUID,
            application_party_type: type,
            party,
            application_party_related,
            profile_related,
          },
        }
      },
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationParties',
        'ApplicationProfiles',
        'Alert',
      ],
    }),
    getSsnUnmaskedParty: builder.query({
      query: ({ external_id, party }) =>
        `v2/applications/${external_id}/application-parties/${party}/get_ssn_unmasked/`,
    }),
    changeContactTypeParty: builder.mutation<
      void,
      { applicationId: string; applicantionPartyId: string; new_type: string }
    >({
      query: (arg) => ({
        url: `v2/applications/${arg.applicationId}/application-parties/${arg.applicantionPartyId}/change-contact-type/`,
        method: 'POST',
        body: { new_type: arg.new_type },
      }),
      invalidatesTags: ['ApplicationProfiles', 'ApplicationParties'],
    }),
  }),
})

export const {
  useListApplicationPartiesQuery,
  useDeleteApplicationPartiesMutation,
  useUpdateApplicationPartyMutation,
  useCreateApplicationPartyMutation,
  useGetSsnUnmaskedPartyQuery,
  useChangeContactTypePartyMutation,
} = applicationPartyV2
